/**
 * 驗證檔案是否包含特定的副檔名
 *
 * @param fileName: 檔案名稱
 * @param extensions: 副檔名的名稱列表
 * @returns Boolean（驗證通過回傳 True）
 */

export const validateFileExtension = (
  fileName: string,
  extensions: string[]
): boolean => {
  const currentExtension: string = fileName
    .substring(fileName.lastIndexOf('.') + 1)
    .toLocaleLowerCase();

  const lowerExtensions = extensions.map((item) => item.toLocaleLowerCase());

  return lowerExtensions.includes(currentExtension);
};
